import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { interval, Subscription } from "rxjs";
import { debounceTime, filter, takeWhile } from 'rxjs/operators';
import swal from "sweetalert2";
import { AreaAutocompleteComponent } from '../../Components/area-autocomplete/area-autocomplete.component';
import { CustomModalComponent } from '../../Components/custom-modal/custom-modal.component';
import { PaginationActionsComponent } from '../../Components/pagination-actions/pagination-actions.component';
import { PaginationActionsService } from '../../Components/pagination-actions/pagination-actions.service';
import { PersonaAreaAutocompleteComponent } from '../../Components/persona-area-autocomplete/persona-area-autocomplete.component';
import { AreaService } from '../../services/area.service';
import { AuthService } from "../../services/auth.service";
import { BandejaService } from '../../services/bandeja.service';
import { BusquedaAvanzadaService } from '../../services/busqueda-avanzada.service';
import { ConfettiService } from '../../services/confetti.service';
import { FavoriteService } from '../../services/favorite.service';
import { PersonaService } from '../../services/persona.service';
import { trimNameValidator } from '../administrador/areas/areas.component';

@Component({
    selector: 'app-usuario-final',
    templateUrl: './usuario-final.component.html',
    styleUrls: ['./usuario-final.component.scss']
})
export class UsuarioFinalComponent implements OnInit, AfterViewInit {

    @ViewChild('favoritesPagination') favoritesPagination: PaginationActionsComponent
    @ViewChild('penddingPagination') penddingPagination: PaginationActionsComponent
    @ViewChild('formularioParametro') formularioParametro: CustomModalComponent
    @ViewChild('formModal') formModal: CustomModalComponent
    @ViewChild('formAlerta') formAlerta: CustomModalComponent
    @ViewChild('jefeAutocomplete') jefeAutocomplete: PersonaAreaAutocompleteComponent
    @ViewChild('asistenteAutocomplete') asistenteAutocomplete: PersonaAreaAutocompleteComponent
    @ViewChild('dependenciaAutocomplete') dependenciaAutocomplete: AreaAutocompleteComponent


    penddingData: any[] = [];
    favoritos: any[] = [];
    favoritosData: { list: any[], [key: string]: any } = { list: [] };

    pendingLoading = false;
    favoriteLoading = false;

    private paddingPage = 1;
    private paddingSize = 20

    private favoritePage = 1
    private favoriteSize = 20

    headers = {};

    data: { list: any[], [key: string]: any } = { list: [] };

    search = new FormControl('', [Validators.required])

    bandeja: any;
    loadingBandejas = true;

    getBandejaSubscription: Subscription;

    idPersona = ''
    correo = ''
    activo = false
    cargandoDetalle: boolean = false;
    listaSede = []
    codArea = 0
    mostrarAlerta: boolean = false;

    formArea = new FormGroup({
        idArea: new FormControl(),
        nombre: new FormControl('', [Validators.required]),
        dependencia: new FormControl('', ),
        idSede: new FormControl('', [Validators.required]),
        idPersonaAa: new FormControl(),
        idPersonaJa: new FormControl(),
        nombreAsistente: new FormControl(),
        nombreJefe: new FormControl(),
        nombrePadreDependencia: new FormControl(),
    }, {validators: trimNameValidator})

    constructor(
        private authService: AuthService,
        private favoriteService: FavoriteService,
        private bandejaService: BandejaService,
        private _busquedaAvazandaService: BusquedaAvanzadaService,
        private _router: Router,
        private service: PaginationActionsService,
        private personaService: PersonaService,
        private areaService: AreaService,
        private confetti: ConfettiService

    ) {
        this.headers = {
            Authorization: 'Bearer ' + this.authService.getUser()
        }
    }

    ngOnInit(): void {
        this.getData();
        this.verificarUsuario();
        this.areaService.getSedes().toPromise().then(res => {
            this.listaSede = res
        })
        this.verificarArea().then(() => {
        });
    }

    buscar() {
        this.search.valueChanges.pipe(
            filter(f => f != null),
            debounceTime(300)
        ).subscribe(value => {
            setTimeout(() => {
                this._busquedaAvazandaService.generalSearch$.next(value);
            }, 1);
            this._router.navigate(['./usuario-final/busqueda-avanzada']);
        })
    }

    ngAfterViewInit() {
        this.penddingPagination.sizeChanges.subscribe(size => {
            this.paddingSize = size
            this.loadPenddingData()
        })

        this.favoritesPagination.sizeChanges.subscribe(size => {
            this.favoriteSize = size
            this.loadFavoritesData()
        })

        this.obtenerBandejaSubscription();
        // this.mostrarModalAlerta();
    }

    obtenerBandejaSubscription() {
        const bandeja = localStorage.getItem('bandeja');
        if (bandeja) {
            this.bandeja = JSON.parse(bandeja);
            this.loadingBandejas = false;
        } else {
            this.getBandejaSubscription = interval(100)
                .pipe(
                    takeWhile(() => !bandeja)
                )
                .subscribe(() => {
                    this.getDataLocalStorage();
                });
        }
    }

    getDataLocalStorage() {
        const bandeja = localStorage.getItem('bandeja');
        if (bandeja) {
            this.bandeja = JSON.parse(localStorage.getItem('bandeja'));
            this.loadingBandejas = false;
            this.stopGetDataLocalStorage();
        } else {
            console.log('No se encontraron datos en el localStorage. Intentando nuevamente en 100ms...');
        }
    }

    stopGetDataLocalStorage() {
        this.getBandejaSubscription.unsubscribe();
    }

    getData(): void {
        this.loadPenddingData()
        this.loadFavoritesData()
    }

    nextPage() {
        if (!this.data.hasNextPage) return;
        this.paddingPage++;
        this.loadPenddingData();
    }

    previusPage() {
        if (!this.data.hasPreviousPage) return;
        this.paddingPage--;
        this.loadPenddingData();
    }

    favoritesPreviusPage() {
        if (!this.favoritosData.hasPreviousPage) return;
        this.favoritePage--;
        this.loadFavoritesData();
    }

    favoritesNextPage() {
        if (!this.favoritosData.hasNextPage) return;
        this.favoritePage++;
        this.loadFavoritesData();
    }

    loadPenddingData() {
        this.pendingLoading = true;
        const params = {
            id: this.authService.getProfile().id,
            estado: 'R',
            page: this.paddingPage,
            size: this.paddingSize,
            order: 'EXPEDIENTE.FECHA_CREACION',
            sort: 'DESC'
        }

        this.bandejaService.listarBandejaPendientesPorPadre(params, this.headers).then((data: any) => {
            this.data = data;
            this.pendingLoading = false;
        })
    }

    loadFavoritesData(forceLoad = false) {
        this.favoriteLoading = true
        const params = {
            idPersona: this.authService.getProfile().id,
            estado: 'R',
            page: this.favoritePage,
            size: this.favoriteSize
        }
        this.favoriteService.favoriteList(params).then(({ data }: any) => {
            this.favoritosData = data
            this.favoriteLoading = false
        })
    }

    updateFavorite(tramite) {
        const params = {
            idExpedienteFav: tramite.idExpedienteFav,
            estado: tramite.estadoExpedienteFav == 'A' ? 'I' : 'A'
        }
        this.favoriteService.updateFavorite({}, { params }).then(res => {
            tramite.estadoExpedienteFav = null
            tramite.idExpedienteFav = null
            this.favoritosData.list = this.favoritosData.list.filter(f => tramite.idExpediente != f.idExpediente)
        })
    }

    submitSearch() {
        this._busquedaAvazandaService.generalSearch$.next(this.search.value);
        this._router.navigate(['/usuario-final/busqueda-avanzada']);
    }

    showFormulario(registro?) {
        this.formularioParametro.open()
    }

    showCambioAsistente(registro?) {
        this.loadArea(registro);
        this.formModal.open()
        this.clearForm()  
        this.jefeAutocomplete.idArea = registro
        this.jefeAutocomplete.findData()
        this.asistenteAutocomplete.idArea = registro
        this.asistenteAutocomplete.findData()
        
        if (registro) {
            this.formArea.get('idPersonaAa').setValidators(Validators.required)
            this.formArea.get('idPersonaJa').setValidators(Validators.required)
            this.formArea.get('idPersonaAa').updateValueAndValidity()
            this.formArea.get('idPersonaJa').updateValueAndValidity()
        }
    }

    async loadArea(id) {
       
        this.cargandoDetalle = true

        const res: any = await this.areaService.detalleArea({ idArea: id })
        console.log(res);
        Object.keys(this.formArea.controls).forEach(key => {
            this.formArea.get(key).setValue(res[key])
        })

        this.jefeAutocomplete.inputControl.setValue(res.nombreJefe)
        this.asistenteAutocomplete.inputControl.setValue(res.nombreAsistente)
        //this.dependenciaAutocomplete.inputControl.setValue(res.nombreDependencia)
        //this.idArea = res.idArea;

        this.cargandoDetalle = false
    }

    clearForm() {
        Object.keys(this.formArea.controls).forEach(key => {
            this.formArea.get(key).setValue('')
        })
    }

    setAsistente(event) {
        this.formArea.get('idPersonaAa').setValue(event.idPersona)
    }

    DataJefe(event) {
        this.formArea.get('idPersonaJa').setValue(event.idPersona)

    }

    verificarUsuario(){
        const id =  this.authService.getProfile().id
        this.idPersona = id;
    
        this.personaService.detalle({ idPersona: this.idPersona}).then( (res:any)=>{
            // console.log("res:::::",res);
          this.activo = (res.notificacionEmail == '1') ? true:false
          this.correo = res.correo;
          if(res.popupInicio!='X'){
            this.confetti.explosive();
            this.mostrarModalAlerta();
          }
        })
    }

    actualizarNotificacion(idPersona, flag, correo){
    let bodyPersona
        bodyPersona = {
          idPersona: idPersona,
          correo: correo,
          notificacionEmail: (flag) ? null:'1'
        }
  
        this.personaService.actualizarNotiEmail(bodyPersona).then((respuesta:any) =>{
          if(respuesta.estado == '1'){
            swal.fire(
                {
                    title: 'Éxito',
                    icon: 'success',
                    text: 'Sus preferencias fueros actualizadas'
                })
          }
    
          this.personaService.detalle({ idPersona: this.idPersona}).then( (res:any)=>{
            this.activo = (res.notificacionEmail == '1') ? true:false
            this.correo = res.correo
          })
        })
  
    }

    actualizarPopupInicio(idPersona, correo){
        let bodyPersona
            bodyPersona = {
              idPersona: idPersona,
              correo: correo,
              popupInicio: 'X'
            }
      
            this.personaService.actualizarPopUpInicio(bodyPersona).then((respuesta:any) =>{
              if(respuesta.estado == '1'){
                this.cerrarModalAlerta(); 
              }
            })
    }

    verificarArea() {
        return new Promise<void>((resolve) => {
          setTimeout(() => {
            const { idArea } = JSON.parse(localStorage.getItem('bandeja') || '{}');
            this.codArea = idArea;
            resolve();
          }, 500);
        });
    }
    

    async guardarArea() {
        if (this.formArea.invalid) {return}
        this.cargandoDetalle = true
        if (this.formArea.get('idArea').value == '') {
            await this.areaService.CrearArea({
                'nombre': this.formArea.controls.nombre.value,
                'dependencia': this.formArea.controls.dependencia.value,
                'idSede': this.formArea.controls.idSede.value
            })
        } else {

            await this.areaService.actualizar({
                'idArea': this.formArea.controls.idArea.value,
                "nombre": this.formArea.controls.nombre.value,
                "dependencia": this.formArea.controls.dependencia.value,
                "idSede": this.formArea.controls.idSede.value,
                "idPersonaAa": this.formArea.controls.idPersonaAa.value,
                "idPersonaJa": this.formArea.controls.idPersonaJa.value,
            })
        }

        this.formModal.close()
        this.cargandoDetalle = false
    }

    cerrarModalAlerta(){
        this.formAlerta.close();
        this.mostrarAlerta = false;
    }

    mostrarModalAlerta(){
        this.mostrarAlerta = true;
        this.formAlerta.open()
        this.confetti.explosive();
    }

    currentIndex = 0;

    sliderItems = [
        { image: 'assets/images/info_main_7.png'},
        { image: 'assets/images/info_main_8.png'},
        { image: 'assets/images/info_main_9.png'},
        { image: 'assets/images/info_main_10.png'}
        // { image: 'assets/images/info_main_5.png'},
        //{ image: 'assets/images/info_main_6.png'}
    ];

    prevSlide() {
        this.currentIndex = (this.currentIndex > 0) ? this.currentIndex - 1 : this.sliderItems.length - 1;
    }

    nextSlide() {
        this.currentIndex = (this.currentIndex < this.sliderItems.length - 1) ? this.currentIndex + 1 : 0;
    }
}
